<template>
  <el-row
type="flex"
justify="space-between"
align="middle">
    <div>
      <h1 class="card-container__title">{{ title }} <span class="card-container__subtitle">({{ total }})</span></h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="permission.CREATE"
        type="primary"
        size="medium"
        icon="el-icon-plus"
        :disabled="disabled"
        :plain="plain"
        @click="$emit('create')"
        >Thêm mới</el-button
      >
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "CardHeader",
  components: {},
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    permission: Object
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
